import { Signal } from "typed-signals";
import { LayoutController } from "onearm";

/**
 * @class HUDStateController
 * @description Controller for managing HUD UI states (Idle, Spinning, FreeSpins, BuyBonus)
 */
export class HUDStateController extends LayoutController {
    init() {
        this.onChangeDoubleChanceToggle = new Signal();

        this.connectChange("DoubleChanceToggle", this.onChangeDoubleChanceToggle);

        this.forAll("FreeSpinsCounter", (counter) => {
            counter.visible = false;
        });
        this.forAll("AddFreeSpinsPopup", (counter) => {
            counter.alpha = 0;
            counter.visible = false;
        });

        this.isDoubleChanceEnabled = false;
    }

    handleDoubleChanceToggle(value) {
        this.setEnabled("BuyBonusButton", !value);
        this.onChangeDoubleChanceToggle.emit(value);
    }

    setDoubleChance(value) {
        this.isDoubleChanceEnabled = value;
        this.setEnabled("BuyBonusButton", !this.isDoubleChanceEnabled);
    }

    setIdleState() {
        this.setEnabled("MinusButton", true);
        this.setEnabled("PlusButton", true);
        this.setEnabled("InfoButton", true);
        this.setEnabled("DoubleChanceToggle", true);
        this.setEnabled("MenuButton", true);
        this.setEnabled("BuyBonusButton", true && !this.isDoubleChanceEnabled);
        this.setEnabled("AutoPlayButton", true);
        this.setEnabled("SpinButton", true);
        this.setEnabled("StopButton", true);
        this.setEnabled("SoundButton", true);
        this.setEnabled("BetButton", true);
        this.setEnabled("TurboSpinButton", true);
        this.setEnabled("QuickSpinButton", true);
        this.setEnabled("NormalSpinButton", true);


        this.setVisible("InfoTextContainer", true);
        this.setVisible("BuyBonusConfirmationPopup", false);
        this.setVisible("BetControlls", false);
    }

    setSpinningState() {
        this.setEnabled("MinusButton", false);
        this.setEnabled("PlusButton", false);
        this.setEnabled("InfoButton", false);
        this.setEnabled("DoubleChanceToggle", false);
        this.setEnabled("MenuButton", false);
        this.setEnabled("BuyBonusButton", false);
        this.setEnabled("AutoPlayButton", false);
        this.setEnabled("BetButton", false);
        this.setEnabled("TurboSpinButton", false);
        this.setEnabled("QuickSpinButton", false);
        this.setEnabled("NormalSpinButton", false);
        this.setVisible("InfoTextContainer", true);

        this.setVisible("BuyBonusConfirmationPopup", false);
        this.setVisible("BetControlls", false);
    }

    setFreeSpinsState() {
        this.setVisible("FreeSpinsCounter", true);
        this.setVisible("AutoPlayButton", false);
        this.setVisible("BuyBonusConfirmationPopup", false);
        this.setVisible("BetControlls", false);
        this.setEnabled("BetButton", false);
        this.setVisible("InfoTextContainer", true);


        this.setEnabled("BuyBonusButton", false);
        this.setEnabled("DoubleChanceToggle", false);
    }

    setMainGameState() {
        this.setVisible("InfoTextContainer", true);
        this.setVisible("FreeSpinsCounter", false);
        this.setVisible("BuyBonusButton", true && !this.isDoubleChanceEnabled);
        this.setVisible("DoubleChanceToggle", true);
        this.setVisible("AutoPlayButton", true);
        this.setEnabled("BetButton", false);
        this.setEnabled("TurboSpinButton", true);
        this.setEnabled("QuickSpinButton", true);
        this.setEnabled("NormalSpinButton", true);


        this.setEnabled("DoubleChanceToggle", true);
    }

    setBuyBonusState() {
        this.setEnabled("MinusButton", false);
        this.setEnabled("PlusButton", false);
        this.setEnabled("InfoButton", false);
        this.setEnabled("DoubleChanceToggle", false);
        this.setEnabled("MenuButton", false);
        this.setEnabled("BuyBonusButton", false);
        this.setEnabled("AutoPlayButton", false);
        this.setEnabled("SpinButton", false);
        this.setEnabled("StopButton", false);
        this.setEnabled("SoundButton", false);
        this.setEnabled("BetButton", false);
        this.setEnabled("TurboSpinButton", false);
        this.setEnabled("QuickSpinButton", false);
        this.setEnabled("NormalSpinButton", false);
        this.setVisible("InfoTextContainer", false);
        this.setVisible("BuyBonusConfirmationPopup", true);
        this.setVisible("BetControlls", true);
    }

    hideBuyBonusPopup() {
        this.setVisible("BuyBonusConfirmationPopup", false);
        this.setVisible("BetControlls", false);
    }

    showAutoplayButton() {
        this.setVisible("AutoPlayButton", true);
        this.setVisible("StopAutoPlayButton", false);
    }

    showStopAutoplayButton() {
        this.setVisible("AutoPlayButton", false);
        this.setVisible("StopAutoPlayButton", true);
    }

    setFreeSpinsCounter(value) {
        this.forAll("FreeSpinsCount", (counter) => {
            counter.text = value;
        });
    }

    /**
     * @description Hides all HUD controls for intro screen
     */
    hideAllControls() {
        const controlNames = [
            "SpinButton",
            "StopButton",
            "InfoButton",
            "MenuButton",
            "BuyBonusButton",
            "AutoPlayButton",
            "StopAutoPlayButton",
            "FullScreenButton",
            "BetPanel",
            "BalancePanel",
            "WinPanel",
            "BetSettingsPanel",
            "SoundVolumeControlls",
        ];

        controlNames.forEach(name => {
            this.setVisible(name, false);
        });
    }
}

